const networkData = {
    "linesOfNetwork": [
        {
            "id": "2ed17465-9da0-4cfa-8088-ab1bd9f0f5d0",
            "name": "Benidorm-Denia_all",
            "networkId": "5169ee7f-d39b-4b9c-bd31-c382f716f688",
            "railwayEdgeIds": "74a0d530-d708-4791-8833-09768e5fcc75"
        }
    ],
    "edgesOfNetwork": [
        {
            "railwayEdgeId": "74a0d530-d708-4791-8833-09768e5fcc75",
            "railwayEdgeName": "E1",
            "networkId": "5169ee7f-d39b-4b9c-bd31-c382f716f688",
            "length": 3773.7685474912296,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        0.0182923,
                        38.639533
                    ],
                    [
                        0.0186768,
                        38.639527
                    ],
                    [
                        0.0189305,
                        38.6395643
                    ],
                    [
                        0.019344091415405277,
                        38.63967652778651
                    ],
                    [
                        0.0198983,
                        38.6398445
                    ],
                    [
                        0.020121932029724125,
                        38.63991117210245
                    ],
                    [
                        0.02077639102935791,
                        38.640099725013954
                    ],
                    [
                        0.021342337131500248,
                        38.64025894708625
                    ],
                    [
                        0.02192705869674683,
                        38.64043492896514
                    ],
                    [
                        0.022471547126770023,
                        38.64067585583667
                    ],
                    [
                        0.022948980331420902,
                        38.64092725692606
                    ],
                    [
                        0.02333521842956543,
                        38.64115561215129
                    ],
                    [
                        0.023804605007171634,
                        38.6415138560385
                    ],
                    [
                        0.02420693635940552,
                        38.641813438732996
                    ],
                    [
                        0.024617314338684086,
                        38.642121400057626
                    ],
                    [
                        0.024992823600769046,
                        38.64246706935583
                    ],
                    [
                        0.02524763345718384,
                        38.64271846416185
                    ],
                    [
                        0.025446116924285892,
                        38.6429237692659
                    ],
                    [
                        0.02567410469055176,
                        38.64308089012169
                    ],
                    [
                        0.026282966136932377,
                        38.64343702945279
                    ],
                    [
                        0.027779638767242435,
                        38.64423309920482
                    ],
                    [
                        0.029163658618927005,
                        38.64494536464469
                    ],
                    [
                        0.02966791391372681,
                        38.645286830565546
                    ],
                    [
                        0.030075609683990482,
                        38.645666002472844
                    ],
                    [
                        0.030429661273956302,
                        38.646055646651945
                    ],
                    [
                        0.03075957298278809,
                        38.646415960888966
                    ],
                    [
                        0.031054615974426273,
                        38.64667362635431
                    ],
                    [
                        0.031365752220153816,
                        38.64686635113735
                    ],
                    [
                        0.032167732715606696,
                        38.6473314022835
                    ],
                    [
                        0.032519102096557624,
                        38.64757649559191
                    ],
                    [
                        0.03280609846115113,
                        38.64785510491576
                    ],
                    [
                        0.032967031002044685,
                        38.64813371315624
                    ],
                    [
                        0.03309041261672974,
                        38.64849611172769
                    ],
                    [
                        0.033114552497863776,
                        38.64881870775786
                    ],
                    [
                        0.03303140401840211,
                        38.64932773620195
                    ],
                    [
                        0.03296434879302979,
                        38.64949322203645
                    ],
                    [
                        0.032843649387359626,
                        38.65027037191904
                    ],
                    [
                        0.032832920551300056,
                        38.650743779845214
                    ],
                    [
                        0.03270417451858521,
                        38.651623556178095
                    ],
                    [
                        0.03260761499404908,
                        38.65236507355376
                    ],
                    [
                        0.032551288604736335,
                        38.6531736120014
                    ],
                    [
                        0.03248423337936402,
                        38.6539800466997
                    ],
                    [
                        0.03241181373596192,
                        38.65490795902873
                    ],
                    [
                        0.03236085176467896,
                        38.65590707466633
                    ],
                    [
                        0.032352805137634284,
                        38.656108152858494
                    ],
                    [
                        0.03236621618270875,
                        38.65631970326383
                    ],
                    [
                        0.03248423337936402,
                        38.65666320952179
                    ],
                    [
                        0.03295898437500001,
                        38.657299948472186
                    ],
                    [
                        0.033144056797027595,
                        38.65753872411928
                    ],
                    [
                        0.0332664,
                        38.6577841
                    ],
                    [
                        0.03333449363708497,
                        38.65796181585488
                    ],
                    [
                        0.033358633518219,
                        38.65821734529655
                    ],
                    [
                        0.0332841,
                        38.6585203
                    ],
                    [
                        0.033111870288848884,
                        38.65881008631101
                    ],
                    [
                        0.0329273,
                        38.6590733
                    ],
                    [
                        0.032655894756317146,
                        38.65941120028042
                    ],
                    [
                        0.032425224781036384,
                        38.65974003052607
                    ],
                    [
                        0.03235816955566407,
                        38.6598803588974
                    ],
                    [
                        0.032248198986053474,
                        38.66022803696122
                    ],
                    [
                        0.0321618,
                        38.6606156
                    ],
                    [
                        0.0320209,
                        38.6610248
                    ],
                    [
                        0.03189146518707276,
                        38.661235456037076
                    ],
                    [
                        0.03171443939208985,
                        38.66140510317754
                    ],
                    [
                        0.03130942583084107,
                        38.66167737552588
                    ],
                    [
                        0.03083199262619019,
                        38.66196430757273
                    ],
                    [
                        0.030502080917358402,
                        38.662154896837066
                    ],
                    [
                        0.0302984,
                        38.6623518
                    ],
                    [
                        0.030129253864288334,
                        38.66253188509671
                    ],
                    [
                        0.03000050783157349,
                        38.66277692640128
                    ],
                    [
                        0.02994954586029053,
                        38.66299892891055
                    ],
                    [
                        0.02993881702423096,
                        38.663254440380626
                    ],
                    [
                        0.02997905015945435,
                        38.66356230954746
                    ],
                    [
                        0.030075609683990482,
                        38.66433413493999
                    ],
                    [
                        0.030102431774139408,
                        38.66467439734865
                    ],
                    [
                        0.030099749565124515,
                        38.6648440363425
                    ],
                    [
                        0.0300592,
                        38.6650017
                    ],
                    [
                        0.029981732368469242,
                        38.66521682185528
                    ],
                    [
                        0.0298182,
                        38.6654311
                    ],
                    [
                        0.029630362987518314,
                        38.66561683111782
                    ],
                    [
                        0.029236078262329105,
                        38.665907935930186
                    ],
                    [
                        0.0293741,
                        38.6658093
                    ]
                ]
            }
        }
    ],
    "network": [
        {
            "networkId": "5169ee7f-d39b-4b9c-bd31-c382f716f688",
            "organisationsId": "08c0ff38-8a71-47c6-a409-14f8a535ec95",
            "networkName": "Benidorm-Denia",
            "networkIcon": null,
            "location": "",
            "mainCity": "",
            "country": "",
            "centerGeoPoint": {
                "type": "Point",
                "coordinates": [
                    0.02930214,
                    38.65266393
                ]
            },
            "active": 1,
            "defaultStartEdge": "74a0d530-d708-4791-8833-09768e5fcc75",
            "lineMeterOnDefaultStartEdge": 0,
            "defaultEndEdge": "74a0d530-d708-4791-8833-09768e5fcc75",
            "lineMeterOnDefaultEndEdge": 0,
            "timeStamp": "0001-01-01T00:00:00",
            "editorStepProcessed": 0,
            "edgeDataExist": false,
            "trackCount": 0
        }
    ]
}

export default networkData